import { render, staticRenderFns } from "./ShowofforumCreate_w_minify.vue?vue&type=template&id=a1d5ba60&"
import script from "./ShowofforumCreate_w_minify.vue?vue&type=script&lang=js&"
export * from "./ShowofforumCreate_w_minify.vue?vue&type=script&lang=js&"
import style0 from "./ShowofforumCreate_w_minify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports